import type { PersonalizableNestedBlok } from '@/helper/personalization/resolvePersonalizedBlocks';

import { getPersonalizedSkeletonForBlok } from './personalizationRegistry';

const PersonalizedContentSkeletons: React.FC<{
  bloks?: PersonalizableNestedBlok[];
}> = ({ bloks }) => {
  if (!bloks?.length) {
    return null;
  }

  return (
    <>
      {bloks.map((blok) => {
        const Skeleton = getPersonalizedSkeletonForBlok(blok);
        return <Skeleton key={blok._uid} blok={blok} />;
      })}
    </>
  );
};

export default PersonalizedContentSkeletons;
